<app-summary-top [header]="header()" [mobile]="true" [showSave]="false"></app-summary-top>
<app-base-form [fields]="fields" [focusFieldIndex]="0" #viewStockForm></app-base-form>
@if (model$ | async; as model) {
  @if (showItemCount() && model.length > 0) {
    <div class="scanner-items-count-bar">
      <i class="fa fa-box-open"></i>
      <span i18n>{{ model.length }} {model.length, plural, =1 {item} other {items}} found</span>
    </div>
  }
  <app-readonly-grid
    [gridCssClass]="gridCssClass()"
    [sizeToFit]="true"
    [stateKey]="header()"
    [columnDefs]="columnDefs"
    [rowData]="model"
  ></app-readonly-grid>
}
